"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = exports.isNumber = exports.isNullOrUndefined = exports.isEmptyObject = exports.isObject = exports.isEmptyString = exports.isDefined = exports.isBoolean = exports.isArray = exports.getSystemDate = exports.getRandomNumber = void 0;
var _ = __importStar(require("lodash"));
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}
exports.getRandomNumber = getRandomNumber;
function getSystemDate() {
    return new Date;
}
exports.getSystemDate = getSystemDate;
function isArray(obj) {
    return Array.isArray(obj);
}
exports.isArray = isArray;
function isBoolean(bool) {
    return (typeof (bool) === "boolean");
}
exports.isBoolean = isBoolean;
function isDefined(obj) {
    return (typeof (obj) !== "undefined");
}
exports.isDefined = isDefined;
function isEmptyString(obj) {
    return (obj === "");
}
exports.isEmptyString = isEmptyString;
function isObject(obj) {
    return obj !== null && obj !== undefined && typeof (obj) === 'object';
}
exports.isObject = isObject;
function isEmptyObject(obj) {
    return isObject(obj) && _.isEmpty(obj);
}
exports.isEmptyObject = isEmptyObject;
function isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(obj) {
    return typeof obj === 'number';
}
exports.isNumber = isNumber;
function isString(obj) {
    return typeof obj === 'string';
}
exports.isString = isString;
